<template>


  <v-container>


    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/logo_f.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Welcome to Frena Accounting
        </h1>

        <p class="subheading font-weight-regular">
          The all-in-one solution for managing a truck repair shop.
        </p>
      </v-col>
    
 
      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
        Γρήγορη πρόσβαση
        </h2>

        <v-row justify="center">
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-row>
      </v-col>
  <v-col cols="12">
        <v-img
          :src="require('../assets/logo_fm_app_l.png')"
          class="my-3"
          contain
          height="250"
        />
      </v-col>
     
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data: () => ({
     apiurl: process.env.VUE_APP_API_ENDPOINT,
      importantLinks: [
        {
          text: 'Τιμολόγια Πωλήσεων',
          href: '/invoices',
        },
        {
          text: 'Προμηθευτές',
          href: '/distributors',
        },
        {
          text: 'Πελάτες',
          href: '/customers',
        },
        {
          text: 'Οχήματα',
          href: '/vehicles',
        },
        {
          text: 'Επισκευές',
          href: '/repairs',
        },
        {
          text: 'Αποθήκη',
          href: '/inventory',
        },
        {
          text: 'Προσφορές',
          href: '/quotes',
        },
        {
          text: 'Οικονομικά',
          href: '/income',
        },
        {
          text: 'Εργαλεία',
          href: '/utils',
        },
      ],
    }),

  }
</script>
